<template>
    <div class="main bg-waves">
        <section id="brn-customer-service" class="diagonal">
            <BorderDecoration class="top-left" style="left: -10%"/>
            <div class="container">
                <div class="row mb-3">
                    <ChalkDecoration class="m-auto">
                        <h2 class="title" v-html="content['customer-service-hero'].data.title"></h2>
                    </ChalkDecoration>
                </div>
                <div class="row">
                    <ChalkDecoration class="m-auto my-3">
                        <h3 class="title" v-html="content['customer-service-hero'].data.disclaimer.title"></h3>
                    </ChalkDecoration>
                    <div v-html="content['customer-service-hero'].data.disclaimer.text"></div>
                </div>
            </div>
            <section id="brn-faq" class="pb-0">
                <div class="container">
                    <ChalkDecoration class="m-auto">
                        <h3 class="text-center" v-html="content['about-faq'].data.title"></h3>
                    </ChalkDecoration>
                    <div class="accordion accordion-faq">
                        <div v-for="(item, index) in content['about-faq'].data.items" :key="index" class="accordion-item">
                            <div class="accordion-header" :id="'faq-heading-' + index">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#faq-collapse-' + index" aria-expanded="false" :aria-controls="'faq-collapse-' + index">
                                    {{ item.question }}
                                </button>
                            </div>
                            <div :id="'faq-collapse-' + index" class="accordion-collapse collapse" :aria-labelledby="'faq-heading-' + index" data-bs-parent="#accordion-faq">
                                <div class="accordion-body" v-html="item.answer"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="container">
                <div class="row">
                    <ChalkDecoration class="m-auto my-3">
                        <h3 class="title" v-html="content['terms-conditions'].data.title"></h3>
                    </ChalkDecoration>
                    <div v-html="content['terms-conditions'].data.text"></div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ChalkDecoration from "../components/elements/ChalkDecoration";
import PageLayoutContentMixin from "../../mixins/ContentMixin";
export default {
    name: "CustomerService",
    components: {ChalkDecoration},
    mixins: [PageLayoutContentMixin],
}
</script>

<style scoped>

</style>
